import React from 'react';

function AnnouncementBanner() {
    return (
        <section>
            <hr />
            <div className="container section-padding">
                <div className="row">
                    <div className="col-md-12">
                        <p style={{ textAlign: 'center' }}>
                            Thank you!
                            <br/><br/>
                            When I started this business, I did it because I had a passion for massage. Thank you for making Beeswax such a success!
                            <br/><br/>
                            Gratitude is a powerful emotion, and because of you, I am overwhelmed with it. It's a privilege to have had the chance to serve you.
                            <br/><br/>
                            Closing Beeswax is bittersweet, please know that if I can serve your future needs at Jinny's Massage I would be honored.
                        </p>
                        <p>
                            Jinny’s new studio: (Jinny’s Massage) <br/>
                            Located at 208 Main Avenue Kaukauna WI 54130 <br/>
                            Phone: 920 462 7120 <br/>
                            Website: <a href="https://www.massagebook.com/therapists/jinnys-massage?src=external">Jinny's Massage</a> <br/>
                        </p>
                        <p>
                            Kim’s new studio: (Transformative Therapeutic Massage) <br/>
                            Located at: 612 E Longview Dr. Appleton, WI 54911<br/>
                            Phone: 920-515-4109<br/>
                            Website: <a href="https://www.massagebook.com/therapists/transformative-therapeutic-massage-?src=external">Transformative Therapeutic Massage</a> <br/>
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
  
export default AnnouncementBanner;